import React, { useState, useRef, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  HttpService,
  Common,
  Permissionkeys,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  DropdownTreeSelect,
  FileUploadWithPreview,
  getBase64,
  Nestable,
  Spinner
} from '../../config/react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
const AddCategory = () => {
  const urlParams = useParams()
  const history = useHistory()
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const validator = useRef(new SimpleReactValidator())
  const [isForceUpdate, setForceUpdate] = useState(false)
  // const [IsShowImageRemoveLink, setIsShowImageRemoveLink] = useState(false)
  const [IsValidFileType, setValidFileType] = useState(true)
  const [CategoryImage, setCategoryImage] = useState('')
  const [Categories, setCategories] = useState([])
  const [Attributes, setAttributes] = useState([])
  const [svgUrl, setsvgUrl] = useState('')

  // images
  const [offer2Img, setoffer2Img] = useState('')
  const [Isoffer2Image, setoffer2Image] = useState(true)
  const [Isoffer2ValidFile, setoffer2ValidFile] = useState(true)
  const [Isoffer2ImageSize, setoffer2ImageSize] = useState(false)

  const [offer1Img, setoffer1Img] = useState('')
  const [Isoffer1Image, setoffer1Image] = useState(true)
  const [Isoffer1ValidFile, setoffer1ValidFile] = useState(true)
  const [Isoffer1ImageSize, setoffer1ImageSize] = useState(false)

  const [DesktopBannerImg, setDesktopBannerImg] = useState('')
  const [IsDesktopBannerImage, setDesktopBannerImage] = useState(true)
  const [IsDesktopBannerValidFile, setDesktopBannerValidFile] = useState(true)
  const [IsDesktopBannerImageSize, setDesktopBannerImageSize] = useState(false)

  const [MobileBannerImg, setMobileBannerImg] = useState('')
  const [IsMobileBannerImage, setMobileBannerImage] = useState(true)
  const [IsMobileBannerValidFile, setMobileBannerValidFile] = useState(true)
  const [IsMobileBannerImageSize, setMobileBannerSize] = useState(false)
  const fileInputRef = useRef()
  const [footerDescription, setfooterDescription] = useState('')
  const [Description, setDescription] = useState('')
  const [Inputs, setInputs] = useState({
    id: 0,
    name: '',
    title: '',
    // description: '',
    slug: '',
    image: '',
    parent_id: 1,
    abbreviation: '',
    meta_title: '',
    meta_description: '',
    meta_keyword: '',
    status: 0,
    is_diamond_category: 0,
    is_gemstone_category: 0,
    is_mto_category: 0,
    is_gift_card: 0,
    order_no: '',
    options: [],
    faqs: [],
    explore_more: [],
    size_attribute_id: 0,
    after_products_1: '',
    after_products_2: '',
    offer_banner_slug_1: '',
    offer_banner_slug_2: '',
    footer_title: ''
  })

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline'], // text styles
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image', 'video'],
      ['clean'] // remove formatting
    ]
  }

  const descriptionModules = {
    toolbar: [['bold', 'italic', 'underline'], ['link']]
  }
  const descriptionFormats = ['bold', 'italic', 'underline', 'strike', 'link']
  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'link',
    'image',
    'video'
  ]

  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.Categories)) {
      history.push('/')
    }
    setIsAuth(true)
    setForceUpdate(!isForceUpdate)
    document.title = Title.AddCategory
    if (urlParams.id !== undefined) {
      document.title = Title.EditCategory
      GetCategoryDetail()
    } else {
      setTimeout(() => {
        //  initImagePlugin()
        initoffer2ImagePlugin()
        initoffer1ImagePlugin()
        initDesktopbannerPlugin()
        initMobilebannerPlugin()
      }, 1000)
      GetCategories()
    }

    GetProductAttributes()
  }, [urlParams.id])

  useEffect(() => {
    updateCategoryDropdown()
  }, [Categories])

  // const initImagePlugin = (image = null) => {
  //   if (image !== '' && image !== null) {
  //     new FileUploadWithPreview('categoryImages', {
  //       text: {
  //         chooseFile: 'Choose Image...'
  //       },
  //       presetFiles: [image]
  //     })
  //   } else {
  //     new FileUploadWithPreview('categoryImages', {
  //       text: {
  //         chooseFile: 'Choose Image...'
  //       }
  //     })
  //   }
  // }
  // offers images plugins

  // SEO Content -----------------
  const handleAddFaqs = (e) => {
    e.preventDefault()
    let FaqsOptions = Inputs.faqs
    if (FaqsOptions === undefined || FaqsOptions === null) FaqsOptions = []
    FaqsOptions.push({ label: '', value: '' })
    const FaqsLabel = 'faqs'
    setInputs({
      ...Inputs,
      [FaqsLabel]: FaqsOptions
    })
    setForceUpdate(!isForceUpdate)
  }
  const handleOnFaqsChange = (index) => (e) => {
    e.preventDefault()
    const FaqsOptions = Inputs.faqs
    FaqsOptions[index] = {
      ...FaqsOptions[index],
      [e.target.name]: e.target.value
    }
    const FaqsLabel = 'faqs'
    setInputs({
      ...Inputs,
      [FaqsLabel]: FaqsOptions
    })
    setForceUpdate(!isForceUpdate)
  }
  const handleDeleteFaqsOption = (index) => (e) => {
    e.preventDefault()
    let FaqsOptions = Inputs.faqs
    FaqsOptions = FaqsOptions.filter(function (item, currentIndex) {
      return currentIndex !== index
    })
    const FaqsLabel = 'faqs'
    setInputs({
      ...Inputs,
      [FaqsLabel]: FaqsOptions
    })
    setForceUpdate(!isForceUpdate)
  }

  const handleAddExploreMoreOptions = (e) => {
    e.preventDefault()
    let ExploreMoreOptions = Inputs.explore_more
    if (ExploreMoreOptions === undefined || ExploreMoreOptions === null) ExploreMoreOptions = []
    ExploreMoreOptions.push({ label: '', value: '' })
    const ExploreMoreLabel = 'explore_more'
    setInputs({
      ...Inputs,
      [ExploreMoreLabel]: ExploreMoreOptions
    })
    setForceUpdate(!isForceUpdate)
  }

  const handleOnExploreMoreChange = (index) => (e) => {
    e.preventDefault()
    const ExploreMoreOptions = Inputs.explore_more
    ExploreMoreOptions[index] = {
      ...ExploreMoreOptions[index],
      [e.target.name]: e.target.value
    }
    const ExploreMoreLabel = 'explore_more'
    setInputs({
      ...Inputs,
      [ExploreMoreLabel]: ExploreMoreOptions
    })
    setForceUpdate(!isForceUpdate)
  }
  const handleDeleteExploreMoreOption = (index) => (e) => {
    e.preventDefault()
    let ExploreMoreOptions = Inputs.explore_more
    ExploreMoreOptions = ExploreMoreOptions.filter(function (item, currentIndex) {
      return currentIndex !== index
    })
    const ExploreMoreLabel = 'explore_more'
    setInputs({
      ...Inputs,
      [ExploreMoreLabel]: ExploreMoreOptions
    })
    setForceUpdate(!isForceUpdate)
  }

  const handleEditorChange = (e) => {
    setfooterDescription(e)
    setForceUpdate(!isForceUpdate)
  }

  const handleDescriptionEditorChange = (e) => {
    setDescription(e)
    setForceUpdate(!isForceUpdate)
  }

  // --------------------------

  const initDesktopbannerPlugin = (image2 = null) => {
    if (image2 !== '' && image2 !== null) {
      new FileUploadWithPreview('DesktopBanner', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image2]
      })
      setDesktopBannerImage(true)
      // setoffer1Image(true)
    } else {
      new FileUploadWithPreview('DesktopBanner', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }
  const initMobilebannerPlugin = (image3 = null) => {
    if (image3 !== '' && image3 !== null) {
      new FileUploadWithPreview('MobileBanner', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image3]
      })
      setMobileBannerImage(true)
      // setoffer1Image(true)
    } else {
      new FileUploadWithPreview('MobileBanner', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }

  const initoffer1ImagePlugin = (image1 = null) => {
    if (image1 !== '' && image1 !== null) {
      new FileUploadWithPreview('offer1image', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image1]
      })
      setoffer1Image(true)
    } else {
      new FileUploadWithPreview('offer1image', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }

  const initoffer2ImagePlugin = (image = null) => {
    if (image !== '' && image !== null) {
      new FileUploadWithPreview('offer2image', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image]
      })
      setoffer2Image(true)
    } else {
      new FileUploadWithPreview('offer2image', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }
  window.addEventListener('fileUploadWithPreview:imagesAdded', function (e) {
    if (e.detail.uploadId === 'offer2image') {
      const imageType = e.detail.cachedFileArray[0].type
      const size = e.detail.cachedFileArray[0].size

      if (
        imageType === 'image/jpeg' ||
        imageType === 'image/jpg' ||
        imageType === 'image/png' ||
        imageType === 'image/webp'
      ) {
        if (size <= 2097152) {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            setoffer2Img(result)
          })
          setoffer2Image(true)
          setoffer2ValidFile(true)
          setoffer2ImageSize(false)
        } else {
          setoffer2ImageSize(true)

          setoffer2Image(true)
          setoffer2Img('')
        }
      } else {
        setoffer2Img('')
        setoffer2Image(true)
        setoffer2ValidFile(false)
        setoffer2ImageSize(false)
      }
    } else if (e.detail.uploadId === 'offer1image') {
      const imageType = e.detail.cachedFileArray[0].type
      const size = e.detail.cachedFileArray[0].size

      if (
        imageType === 'image/jpeg' ||
        imageType === 'image/jpg' ||
        imageType === 'image/png' ||
        imageType === 'image/webp'
      ) {
        if (size <= 2097152) {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            setoffer1Img(result)
          })
          setoffer1Image(true)
          setoffer1ValidFile(true)
          setoffer1ImageSize(false)
        } else {
          setoffer1ImageSize(true)
        }
      } else {
        setoffer1Img('')
        setoffer1Image(true)
        setoffer1ValidFile(false)
        setoffer1ImageSize(false)
      }
    } else if (e.detail.uploadId === 'MobileBanner') {
      const imageType = e.detail.cachedFileArray[0].type
      const size = e.detail.cachedFileArray[0].size

      if (
        imageType === 'image/jpeg' ||
        imageType === 'image/jpg' ||
        imageType === 'image/png' ||
        imageType === 'image/webp'
      ) {
        if (size <= 2097152) {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            setMobileBannerImg(result)
          })
          setMobileBannerImage(true)
          setMobileBannerValidFile(true)
          setMobileBannerSize(false)
        } else {
          setMobileBannerSize(true)

          setMobileBannerImage(true)
          setMobileBannerImg('')
        }
      } else {
        setMobileBannerImg('')
        setMobileBannerImage(true)
        setMobileBannerValidFile(false)
        setMobileBannerSize(false)
      }
    } else if (e.detail.uploadId === 'DesktopBanner') {
      const imageType = e.detail.cachedFileArray[0].type
      const size = e.detail.cachedFileArray[0].size

      if (
        imageType === 'image/jpeg' ||
        imageType === 'image/jpg' ||
        imageType === 'image/png' ||
        imageType === 'image/webp'
      ) {
        if (size <= 2097152) {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            setDesktopBannerImg(result)
          })
          setDesktopBannerImage(true)
          setDesktopBannerValidFile(true)
          setDesktopBannerImageSize(false)
        } else {
          setDesktopBannerImageSize(true)

          setDesktopBannerImage(true)
          setDesktopBannerImg('')
        }
      } else {
        setDesktopBannerImg('')
        setDesktopBannerImage(true)
        setDesktopBannerValidFile(false)
        setDesktopBannerImageSize(false)
      }
    }
  })
  window.addEventListener('fileUploadWithPreview:clearButtonClicked', function (e) {
    if (e.detail.uploadId === 'offer2image') {
      setoffer2Img('')
      setoffer2ValidFile(true)
      setoffer2ImageSize(false)
      // setoffer2Image(true)
    } else if (e.detail.uploadId === 'offer1image') {
      setoffer1Img('')
      setoffer1ValidFile(true)
      setoffer1ImageSize(false)
    } else if (e.detail.uploadId === 'DesktopBanner') {
      setDesktopBannerImg('')
      setDesktopBannerValidFile(true)
      setDesktopBannerImageSize(false)
    } else if (e.detail.uploadId === 'MobileBanner') {
      setMobileBannerImg('')
      setMobileBannerValidFile(true)
      setMobileBannerSize(false)
    }
  })
  const GetCategoryDetail = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetCategory, param).then((response) => {
      setLoading(false)

      if (response.data.result) {
        const data = response.data.result
        setfooterDescription(data[0].footer_description)
        setDescription(data[0].description)
        setInputs(data[0])

        GetCategories(data[0].parent_id)
        // setValidFileType(false)
        setTimeout(() => {
          if (data[0].offer_image_1 !== '') {
            initoffer1ImagePlugin(data[0].offer_image_1)
          } else {
            initoffer1ImagePlugin()
          }
          if (data[0].offer_image_2 !== '') {
            initoffer2ImagePlugin(data[0].offer_image_2)
          } else {
            initoffer2ImagePlugin()
          }
          if (data[0].DesktopBannerImage !== '') {
            initDesktopbannerPlugin(data[0].DesktopBannerImage)
          } else {
            initDesktopbannerPlugin()
          }
          if (data[0].MobileBannerImage !== '') {
            initMobilebannerPlugin(data[0].MobileBannerImage)
          } else {
            initMobilebannerPlugin()
          }
        }, 1000)
        setsvgUrl(data[0].image)
        setCategoryImage(data[0].image)

        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const onChangeCategory = (currentNode, selectedNodes) => {
    if (selectedNodes.length > 0) {
      Inputs.parent_id = selectedNodes[0].value
    } else {
      Inputs.parent_id = 1
    }
    // setForceUpdate(!isForceUpdate)
  }
  const GetCategories = (selectedCategory = null) => {
    setLoading(true)
    HttpService.postApi(API.GetCategory, null).then((response) => {
      setLoading(false)
      if (response.data.result) {
        // filter parent category
        const parentCategories = response.data.result[0].filter((x) => x.parent_id === 1)
        const categories = []

        parentCategories.map((item) => {
          // filter sub categories by parent
          const filteredSubcategories = response.data.result[0].filter(
            (x) => x.parent_id === item.id
          )
          const subcategories = []

          filteredSubcategories.map((subitem) => {
            const filteredSubchildcategories = response.data.result[0].filter(
              (y) => y.parent_id === subitem.id
            )

            const subchildcategories = []

            filteredSubchildcategories.map((subchilditem) => {
              let checked = false
              if (
                (urlParams.id !== undefined && Inputs.parent_id === subchilditem.id) ||
                selectedCategory === subchilditem.id
              )
                checked = true
              subchildcategories.push({
                label: subchilditem.name,
                value: subchilditem.id,
                checked,
                children: null
              })
              return true
            })

            let checked = false
            if (
              (urlParams.id !== undefined && Inputs.parent_id === subitem.id) ||
              selectedCategory === subitem.id
            )
              checked = true
            subcategories.push({
              label: subitem.name,
              value: subitem.id,
              checked,
              children: subchildcategories
            })
            return true
          })

          let checked = false
          if (
            (urlParams.id !== undefined && Inputs.parent_id === item.id) ||
            selectedCategory === item.id
          )
            checked = true
          categories.push({
            label: item.name,
            value: item.id,
            children: subcategories,
            checked
          })
          return true
        })
        setCategories(categories)
        // setForceUpdate(!isForceUpdate)
      }
    })
  }
  const GetProductAttributes = () => {
    setLoading(true)
    HttpService.postApi(API.GetProductAttributeList, {}).then((response) => {
      setLoading(false)
      setAttributes(response.data.result[0])
      setForceUpdate(!isForceUpdate)
    })
  }
  const handleInputChanges = (prop) => (event) => {
    if (
      prop === 'status' ||
      prop === 'is_diamond_category' ||
      prop === 'is_gemstone_category' ||
      prop === 'is_mto_category' ||
      prop === 'is_gift_card'
    )
      setInputs({ ...Inputs, [prop]: event.target.checked })
    else setInputs({ ...Inputs, [prop]: event.target.value })
    setForceUpdate(!isForceUpdate)
    updateCategoryDropdown()
  }

  const updateCategoryDropdown = (e) => {
    Categories.map((item, index) => {
      if (item.value === Inputs.parent_id) {
        Categories[index].checked = true
      } else {
        Categories[index].checked = false
      }
      item.children.map((subitem, subindex) => {
        if (subitem.value === Inputs.parent_id) {
          Categories[index].children[subindex].checked = true
        } else {
          Categories[index].children[subindex].checked = false
        }
        return true
      })
      return true
    })
  }

  const SubmitForm = (e) => {
    if (
      !validator.current.allValid() ||
      Isoffer1ImageSize === true ||
      Isoffer2ImageSize === true ||
      Isoffer1ValidFile === false ||
      Isoffer2ValidFile === false
    ) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }
    if (!IsValidFileType) {
      return
    }

    const param = {
      id: Inputs.id,
      name: Common.capitalizeString(Inputs.name.trim()),
      title: Common.capitalizeString(Inputs.title.trim()),
      description: Description || '',
      slug: formatSlug(Inputs.slug),
      image: CategoryImage,
      parent_id: Inputs.parent_id !== '' && Inputs.parent_id !== null ? Inputs.parent_id : 1,
      abbreviation: Inputs.abbreviation,
      meta_title: Inputs.meta_title,
      meta_description: Inputs.meta_description,
      meta_keyword: Inputs.meta_keyword,
      status: Inputs.status ?? 0,
      is_diamond_category: Inputs.is_diamond_category ?? 0,
      is_gemstone_category: Inputs.is_gemstone_category ?? 0,
      is_mto_category: Inputs.is_mto_category ?? 0,
      is_gift_card: Inputs.is_gift_card ?? 0,
      order_no: Inputs.order_no.length < 1 ? 0 : Inputs.order_no,
      filter_option: Inputs.options !== null ? Inputs.options : '',
      size_attribute_id:
        Inputs.size_attribute_id === '' || Inputs.size_attribute_id === null
          ? 0
          : Inputs.size_attribute_id,
      offer_image_1: offer1Img,
      offer_image_2: offer2Img,
      after_products_1: Inputs.after_products_1,
      after_products_2: Inputs.after_products_2,
      offer_banner_slug_1: Inputs.offer_banner_slug_1,
      offer_banner_slug_2: Inputs.offer_banner_slug_2,
      DesktopBannerImage: DesktopBannerImg,
      MobileBannerImage: MobileBannerImg,
      footer_title: Inputs.footer_title,
      footer_description: footerDescription,
      faqs: Inputs.faqs !== null && Inputs.faqs.length > 0 ? Inputs.faqs : [],
      explore_more:
        Inputs.explore_more !== null && Inputs.explore_more.length > 0 ? Inputs.explore_more : []
    }
    setLoading(true)
    HttpService.postApi(API.SetCategory, param).then((response) => {
      setLoading(false)
      if (response.data.message) {
        toast.warning(response.data.message)
        setForceUpdate(!isForceUpdate)
        return
      }
      if (urlParams.id !== undefined) toast.success(Messages.RecordUpdated)
      else toast.success(Messages.RecordAdded)
      setForceUpdate(!isForceUpdate)
      history.push('/categories')
    })
  }
  const addOption = (e) => {
    e.preventDefault()
    let options = Inputs.options
    if (options === undefined || options === null) options = []
    options.push({
      id: Math.floor(1000 + Math.random() * 9000),
      value: '',
      sort_order: options.length > 0 ? Math.max(...options.map((o) => o.sort_order)) + 1 : 0
    })
    setInputs({ ...Inputs, options })
    setForceUpdate(!isForceUpdate)
  }
  const handleDelete = (i) => (e) => {
    e.preventDefault()
    let options = [...Inputs.options]
    options = options.filter((x) => x.id !== i)
    Inputs.options = options
    setForceUpdate(!isForceUpdate)
  }
  const styles = {
    position: 'relative',
    padding: '10px 15px',
    fontSize: '15px',
    border: '1px solid #f9fafa',
    background: '#f9fafa',
    cursor: 'move'
  }
  const handleText = (i) => (e) => {
    const options = [...Inputs.options]
    const index = options.findIndex((x) => x.value === i)
    options[index] = {
      id: index,
      value: e.target.value,
      sort_order: options[index].sort_order !== undefined ? options[index].sort_order : 0
    }
    setInputs({ ...Inputs, options })
    setForceUpdate(!isForceUpdate)
  }
  const renderItem = (item) => {
    return (
      <div style={styles}>
        <div className="row form-group mb-0">
          <div className="col pr-1">
            <select
              className="form-control"
              name="options[]"
              data-id={item.item.id}
              onChange={handleText(item.item.value)}
              value={item.item.value}
            >
              <option value="">Please Select</option>
              {Attributes.length > 0 &&
                Attributes.map((item, index) => (
                  <option
                    key={index}
                    value={item.id}
                    disabled={
                      Inputs.options.filter((option) => Number(option.value) === Number(item.id))
                        .length > 0
                    }
                  >
                    {item.attribute_name} - {item.attribute_code}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-auto pl-1">
            <button
              className="btn btn-danger input-btn btn-block"
              onClick={handleDelete(item.item.id)}
            >
              X
            </button>
          </div>
        </div>
      </div>
    )
  }
  const changeOptionOrder = (item) => {
    const attributeOptions = []
    item.items.map((item, index) => {
      attributeOptions.push({
        id: Math.floor(1000 + Math.random() * 9000),
        option_id: Math.floor(1000 + Math.random() * 9000),
        value: item.value,
        sort_order: index
      })
      return true
    })
    setInputs({ ...Inputs, options: attributeOptions })
    if (urlParams.id !== undefined) {
      const param = {
        items: attributeOptions
      }
      HttpService.postApi(API.ChangeCategoryAttributeOrder, param).then((response) => {})
    }
  }
  const handleCategoryImage = async (e) => {
    if (e.target.files[0].type === 'image/svg+xml') {
      const finalImage = await new Promise((resolve, reject) => {
        getBase64(e.target.files[0], (result) => {
          resolve(result)
        })
      })
      setsvgUrl(finalImage)
      setCategoryImage(finalImage)
      setForceUpdate(!isForceUpdate)
      setValidFileType(true)
    } else {
      setValidFileType(false)
    }
  }
  const RemoveImage = (e, inputRef) => {
    setValidFileType(true)
    e.preventDefault()
    setCategoryImage(null)
    setsvgUrl(' ')
    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }
  function formatSlug(value) {
    const slug = value.trim()
    return slug.replace(/(?<=.)\s(?=.)/g, '-')
  }

  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id !== undefined ? Title.EditCategory : Title.AddCategory}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={handleInputChanges('name')}
                        onKeyUp={handleInputChanges('name')}
                        onBlur={() => validator.current.showMessageFor('Name')}
                        defaultValue={Inputs.name}
                        placeholder="Name"
                      />
                      {validator.current.message('Name', Inputs.name, 'required|max:255', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Title</label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        onChange={handleInputChanges('title')}
                        onKeyUp={handleInputChanges('title')}
                        defaultValue={Inputs.title}
                        placeholder="Title"
                      />
                      {validator.current.message('Title', Inputs.title, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Description</label>

                      <ReactQuill
                        theme="snow"
                        value={Description} // ✅ controlled value
                        onChange={handleDescriptionEditorChange} // ✅ updates state
                        modules={descriptionModules}
                        formats={descriptionFormats}
                        style={{ height: 100, marginBottom: '70px' }}
                      />

                      {/* <textarea
                        className="form-control"
                        name="description"
                        onChange={handleInputChanges('description')}
                        onKeyUp={handleInputChanges('description')}
                        onBlur={() => validator.current.showMessageFor('Description')}
                        defaultValue={Inputs.description}
                        placeholder="Description"
                      ></textarea> */}

                      {/* {validator.current.message('Description', Inputs.description, 'required', {
                        className: 'error'
                      })} */}
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Slug</label>
                          <input
                            type="text"
                            className="form-control"
                            name="slug"
                            onChange={handleInputChanges('slug')}
                            onKeyUp={handleInputChanges('slug')}
                            onBlur={() => validator.current.showMessageFor('Slug')}
                            defaultValue={Inputs.slug}
                            placeholder="Slug"
                          />
                          {validator.current.message('Slug', Inputs.slug, 'required|max:70', {
                            className: 'error'
                          })}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Parent Category</label>
                          {Categories.length > 0 && (
                            <DropdownTreeSelect
                              data={Categories}
                              onChange={onChangeCategory}
                              mode="radioSelect"
                              className="bootstrap-demo w-100"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-md-4">
                    <div className="form-group">
                      <label>Abbreviation</label>
                      <input
                        type="text"
                        className="form-control"
                        name="abbreviation"
                        onChange={handleInputChanges('abbreviation')}
                        onKeyUp={handleInputChanges('abbreviation')}
                        onBlur={() => validator.current.showMessageFor('Abbreviation')}
                        defaultValue={Inputs.abbreviation}
                        placeholder="Abbreviation"
                      />
                      {validator.current.message('Abbreviation', Inputs.abbreviation, 'max:255', {
                        className: 'error'
                      })}
                    </div>
                  </div> */}
                  {/* <div className="col-md-4">
                    <div className="form-group mb-0">
                      <label>
                        Image <small className="note ml-1">{'(only .svg format is allowed)'}</small>
                      </label>
                    </div>
                    <div className="form-group">
                      <input
                        type="file"
                        name="categoryimage"
                        className="form-control mr-2 option-image-file "
                        id={'category_image'}
                        style={{ display: 'block' }}
                        onChange={(e) => handleCategoryImage(e)}
                      />

                      <div className="btn-remove-image ">
                        <Link
                          className="custom-file-container__image-clear float-right"
                          title="Remove Image"
                          onClick={(e) => RemoveImage(e)}
                        >
                          &times;
                        </Link>
                    
                        <div className="menu-svg-icon">
                          {' '}
                          <img src={svgUrl} />
                        </div>
                      </div>

                      <div
                        style={!IsValidFileType ? {} : { display: 'none' }}
                        className="error"
                      >
                        The file format is not supported.
                      </div>
                    </div>
                  </div> */}

                  {/* <div className="col-md-4">
                    <div className="form-group">
                      <label>Size Attribute</label>
                      <select
                        className="form-control"
                        name="size_attribute_id"
                        onChange={handleInputChanges('size_attribute_id')}
                        value={Inputs.size_attribute_id}
                      >
                        <option value="">Select</option>
                        {Attributes.length > 0 &&
                          Attributes.map((item, index) => (
                            <option
                              key={index}
                              value={item.id}
                            >
                              {item.attribute_name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div> */}
                  {/* <div className="col-md-4">
                    <div className="form-group">
                      <label>Order No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="order_no"
                        onChange={handleInputChanges('order_no')}
                        onKeyUp={handleInputChanges('order_no')}
                        value={Inputs.order_no === 0 ? '' : Inputs.order_no}
                        placeholder="Order No"
                      />
                      {validator.current.message('Order No', Inputs.order_no, 'numeric|min:0,num', {
                        className: 'error'
                      })}
                    </div>
                  </div> */}
                  <div className="col-md-3">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges('status')}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Is Diamond Category
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="is_diamond_category"
                            onChange={handleInputChanges('is_diamond_category')}
                            id="is_diamond_category"
                            checked={Inputs.is_diamond_category}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="is_diamond_category"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Is Gemstone Category
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="is_gemstone_category"
                            onChange={handleInputChanges('is_gemstone_category')}
                            id="is_gemstone_category"
                            checked={Inputs.is_gemstone_category}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="is_gemstone_category"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Is MTO Category
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="is_mto_category"
                            onChange={handleInputChanges('is_mto_category')}
                            id="is_mto_category"
                            checked={Inputs.is_mto_category}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="is_mto_category"
                          ></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Is Gift Card Category
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="is_gift_card"
                            onChange={handleInputChanges('is_gift_card')}
                            id="is_gift_card"
                            checked={Inputs.is_gift_card}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="is_gift_card"
                          ></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div
                      id="accordion"
                      className="custom-accordion"
                    >
                      <div className="card shadow-none border-bottom mt-2">
                        <a
                          data-toggle="collapse"
                          data-target="#collapseZero"
                          aria-expanded="true"
                          aria-controls="collapseZero"
                          className="collapsed"
                        >
                          <div className="card-header border-none px-3">
                            <label className="mb-0">Media</label>
                            <i className="fa fa-chevron-down fs-12 float-right"></i>
                          </div>
                        </a>

                        <div
                          id="collapseZero"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body p-3 pt-0 font-dark">
                            <div className="row">
                              {' '}
                              <div className="col d-none">
                                <div className="form-group mb-0 mt-3">
                                  <label>
                                    Image Icon{' '}
                                    <small className="note ml-1 ">
                                      {'(only .svg format is allowed)'}
                                    </small>
                                  </label>
                                </div>
                                <div className="form-group mt-4">
                                  <input
                                    type="file"
                                    accept="image/svg+xml"
                                    name="categoryimage"
                                    className="form-control mr-2 option-image-file "
                                    id={'category_image'}
                                    style={{ display: 'block' }}
                                    ref={fileInputRef}
                                    onChange={(e) => handleCategoryImage(e)}
                                  />

                                  <div className="btn-remove-image ">
                                    <Link
                                      className="custom-file-container__image-clear float-right"
                                      title="Remove Image"
                                      onClick={(e) => RemoveImage(e, fileInputRef)}
                                    >
                                      &times;
                                    </Link>

                                    <div className="menu-svg-icon">
                                      {' '}
                                      <img src={svgUrl} />
                                    </div>
                                  </div>

                                  <div
                                    style={!IsValidFileType ? {} : { display: 'none' }}
                                    className="error"
                                  >
                                    The file format is not supported.
                                  </div>
                                </div>
                              </div>
                              <div className="col">
                                <div className="form-group mt-3">
                                  <label>
                                    Desktop Banner
                                    <small className="note ml-1">
                                      {'(Only PNG, JPEG, JPG format allowed.)'}
                                    </small>
                                  </label>
                                  <div
                                    className="custom-file-container mb-2"
                                    data-upload-id="DesktopBanner"
                                  ></div>
                                  <div
                                    style={
                                      IsDesktopBannerImage
                                        ? { display: 'none' }
                                        : { display: 'block' }
                                    }
                                  >
                                    <small className="error">Image is required.</small>
                                  </div>
                                  <div
                                    style={!IsDesktopBannerValidFile ? {} : { display: 'none' }}
                                    className="error pt-2 pb-4"
                                  >
                                    {Messages.formatnotsupport}
                                  </div>
                                  <div
                                    style={IsDesktopBannerImageSize ? {} : { display: 'none' }}
                                    className="error pt-0 pb-2"
                                  >
                                    Maximum file size should be 2MB.
                                  </div>
                                </div>
                              </div>
                              <div className="col">
                                <div className="form-group mt-3">
                                  <label>
                                    Mobile Banner
                                    <small className="note ml-1">
                                      {'(Only PNG, JPEG, JPG format allowed.)'}
                                    </small>
                                  </label>
                                  <div
                                    className="custom-file-container mb-4"
                                    data-upload-id="MobileBanner"
                                  ></div>
                                  <div
                                    style={
                                      IsMobileBannerImage
                                        ? { display: 'none' }
                                        : { display: 'block' }
                                    }
                                  >
                                    <small className="error">Image is required.</small>
                                  </div>

                                  <div
                                    style={!IsMobileBannerValidFile ? {} : { display: 'none' }}
                                    className="error pt-2 pb-4"
                                  >
                                    {Messages.formatnotsupport}
                                  </div>
                                  <div
                                    style={IsMobileBannerImageSize ? {} : { display: 'none' }}
                                    className="error pt-0 pb-2"
                                  >
                                    Maximum file size should be 2MB.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none border-top border-bottom">
                        <a
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                          className="collapsed"
                        >
                          <div className="card-header border-none px-3">
                            <label className="mb-0">Search Engine Optimization</label>
                            <i className="fa fa-chevron-down fs-12 float-right"></i>
                          </div>
                        </a>

                        <div
                          id="collapseOne"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body p-3 pt-0 font-dark">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Meta Title</label>
                                  <textarea
                                    className="form-control"
                                    name="meta_title"
                                    onChange={handleInputChanges('meta_title')}
                                    onKeyUp={handleInputChanges('meta_title')}
                                    defaultValue={Inputs.meta_title}
                                    placeholder="Meta Title"
                                  ></textarea>
                                  {/* {validator.current.message('Meta title', Inputs.meta_title, 'required', { className: 'error' })} */}
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Meta Description</label>
                                  <textarea
                                    className="form-control"
                                    name="meta_description"
                                    onChange={handleInputChanges('meta_description')}
                                    onKeyUp={handleInputChanges('meta_description')}
                                    defaultValue={Inputs.meta_description}
                                    placeholder="Meta Description"
                                  ></textarea>
                                  {/* {validator.current.message('Meta Description', Inputs.meta_description, 'required', { className: 'error' })} */}
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Meta Keyword</label>
                                  <textarea
                                    className="form-control"
                                    name="meta_keyword"
                                    onChange={handleInputChanges('meta_keyword')}
                                    onKeyUp={handleInputChanges('meta_keyword')}
                                    defaultValue={Inputs.meta_keyword}
                                    placeholder="Meta Keyword"
                                  ></textarea>
                                  {validator.current.message(
                                    'Meta Keyword',
                                    Inputs.meta_keyword,
                                    'max:255',
                                    {
                                      className: 'error'
                                    }
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none border-bottom mt-2">
                        <a
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                          className="collapsed"
                        >
                          <div className="card-header border-none px-3">
                            <label className="mb-0">Offer Banner</label>
                            <i className="fa fa-chevron-down fs-12 float-right"></i>
                          </div>
                        </a>

                        <div
                          id="collapseTwo"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body p-3 pt-0 font-dark">
                            <div className="row">
                              {' '}
                              <div className="col">
                                <div className="form-group">
                                  <label>After Products </label>
                                  <input
                                    name="skip_item_offer1"
                                    type="number"
                                    min={0}
                                    onBlur={() =>
                                      validator.current.showMessageFor('skip_item_offer1')
                                    }
                                    value={Inputs.after_products_1}
                                    onChange={handleInputChanges('after_products_1')}
                                    className="form-control"
                                    placeholder="After Products"
                                  />
                                  {/* {validator.current.message(
                          'Skip Item',
                          Inputs.after_products_1,
                          'required|max:50',
                          {
                            className: 'error'
                          }
                        )} */}
                                </div>

                                <div className="form-group mt-3">
                                  <label>Offer Slug 1</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="offer_banner_slug_1"
                                    onChange={handleInputChanges('offer_banner_slug_1')}
                                    onKeyUp={handleInputChanges('offer_banner_slug_1')}
                                    onBlur={() =>
                                      validator.current.showMessageFor('offer_banner_slug_1')
                                    }
                                    defaultValue={Inputs.offer_banner_slug_1}
                                    placeholder="offer banner slug"
                                  />
                                </div>
                                <div className="form-group mt-3">
                                  <label>
                                    Offer Image 1
                                    <small className="note ml-1">
                                      {'(Only PNG, JPEG, JPG format allowed.)'}
                                    </small>
                                  </label>
                                  <div
                                    className="custom-file-container mb-2"
                                    data-upload-id="offer1image"
                                  ></div>
                                  <div
                                    style={
                                      Isoffer1Image ? { display: 'none' } : { display: 'block' }
                                    }
                                  >
                                    <small className="error">Image is required.</small>
                                  </div>
                                  <div
                                    style={!Isoffer1ValidFile ? {} : { display: 'none' }}
                                    className="error pt-2 pb-4"
                                  >
                                    {Messages.formatnotsupport}
                                  </div>
                                  <div
                                    style={Isoffer1ImageSize ? {} : { display: 'none' }}
                                    className="error pt-0 pb-2"
                                  >
                                    Maximum file size should be 2MB.
                                  </div>
                                </div>
                              </div>
                              <div className="col">
                                <div className="form-group">
                                  <label>After Products</label>
                                  <input
                                    name="skip_item_offer2"
                                    type="number"
                                    onBlur={() =>
                                      validator.current.showMessageFor('skip_item_offer2')
                                    }
                                    min={0}
                                    value={Inputs.after_products_2}
                                    onChange={handleInputChanges('after_products_2')}
                                    className="form-control"
                                    placeholder="After Products"
                                  />
                                  {/* {validator.current.message(
                          'Skip Item',
                          Inputs.after_products_2,
                          'required|max:50',
                          {
                            className: 'error'
                          }
                        )} */}
                                </div>

                                <div className="form-group mt-3">
                                  <label>Offer Slug 2</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="offer_banner_slug_2"
                                    onChange={handleInputChanges('offer_banner_slug_2')}
                                    onKeyUp={handleInputChanges('offer_banner_slug_2')}
                                    onBlur={() =>
                                      validator.current.showMessageFor('offer_banner_slug_2')
                                    }
                                    defaultValue={Inputs.offer_banner_slug_2}
                                    placeholder="offer banner slug"
                                  />
                                </div>
                                <div className="form-group mt-3">
                                  <label>
                                    Offer Image 2
                                    <small className="note ml-1">
                                      {'(Only PNG, JPEG, JPG format allowed.)'}
                                    </small>
                                  </label>
                                  <div
                                    className="custom-file-container mb-2"
                                    data-upload-id="offer2image"
                                  ></div>
                                  <div
                                    style={
                                      Isoffer2Image ? { display: 'none' } : { display: 'block' }
                                    }
                                  >
                                    <small className="error">Image is required.</small>
                                  </div>

                                  <div
                                    style={!Isoffer2ValidFile ? {} : { display: 'none' }}
                                    className="error pt-2 pb-4"
                                  >
                                    {Messages.formatnotsupport}
                                  </div>
                                  <div
                                    style={Isoffer2ImageSize ? {} : { display: 'none' }}
                                    className="error pt-0 pb-2"
                                  >
                                    {Isoffer2ImageSize}
                                    Maximum file size should be 2MB.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none border-bottom mt-2">
                        <a
                          data-toggle="collapse"
                          data-target="#collapseThird"
                          aria-expanded="true"
                          aria-controls="collapseThird"
                          className="collapsed"
                        >
                          <div className="card-header border-none px-3">
                            <label className="mb-0">Filter Options</label>
                            <i className="fa fa-chevron-down fs-12 float-right"></i>
                          </div>
                        </a>
                        <div
                          id="collapseThird"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body pb-3 px-3 pt-2 font-dark">
                            <div className="row">
                              <div className="col-md-2 order-lg-2">
                                <div className="row">
                                  <div className="form-group mb-0 col-md-12 text-right">
                                    {/* <label>Filter Options</label> */}
                                    <button
                                      className="btn btn-dark"
                                      onClick={addOption}
                                    >
                                      Add Option
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-10 order-lg-1">
                                <div className="row">
                                  <div className="col-lg-6 mb-2">
                                    <p></p>
                                    {Inputs.options?.length > 0 && (
                                      <Nestable
                                        items={Inputs.options}
                                        renderItem={renderItem}
                                        collapsed={false}
                                        onChange={changeOptionOrder}
                                        maxDepth={1}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none border-bottom mt-2">
                        <a
                          data-toggle="collapse"
                          data-target="#collapseFour"
                          aria-expanded="true"
                          aria-controls="collapseFour"
                          className="collapsed"
                        >
                          <div className="card-header border-none px-3">
                            <label className="mb-0">FAQs</label>
                            <i className="fa fa-chevron-down fs-12 float-right"></i>
                          </div>
                        </a>
                        <div
                          id="collapseFour"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body p-3 pt-0 font-dark">
                            <div className="row">
                              <div className="col-md-12 order-lg-1">
                                <div className="row">
                                  {Inputs.faqs !== null &&
                                    Inputs.faqs.map((item, index) => (
                                      <>
                                        <div className="col-md-5">
                                          <div className="form-group">
                                            <label htmlFor={'_label_' + index}>Question</label>
                                            <input
                                              type="text"
                                              name="label"
                                              className="form-control"
                                              id={'_label_' + index}
                                              value={item.label}
                                              onChange={handleOnFaqsChange(index)}
                                            />
                                            {/* {validator.current.message(
                                              'Question',
                                              item.label,
                                              'required',
                                              { className: 'error' }
                                            )} */}
                                          </div>
                                        </div>
                                        <div className="col-md-6">
                                          <div className="form-group">
                                            <label htmlFor={'_value_' + index}>Answer</label>
                                            <textarea
                                              type="text"
                                              name="value"
                                              className="form-control"
                                              id={'_value_' + index}
                                              value={item.value}
                                              onChange={handleOnFaqsChange(index)}
                                            />
                                            {/* {validator.current.message(
                                              'Answer',
                                              item.value,
                                              'required',
                                              { className: 'error' }
                                            )} */}
                                          </div>
                                        </div>
                                        <div className="col-auto pr-0">
                                          <button
                                            className="btn btn-danger input-btn btn-block mt-4 w-48"
                                            onClick={handleDeleteFaqsOption(index)}
                                          >
                                            X
                                          </button>
                                        </div>
                                      </>
                                    ))}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-10 order-lg-1"></div>
                              <div className="col-md-2 order-lg-2">
                                <div className="row">
                                  <div className="col-md-9 text-right p-0">
                                    <button
                                      type="button"
                                      className="btn btn-custom text-white"
                                      onClick={(e) => handleAddFaqs(e)}
                                    >
                                      + Add New
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none border-bottom mt-2">
                        <a
                          data-toggle="collapse"
                          data-target="#collapseFive"
                          aria-expanded="true"
                          aria-controls="collapseFive"
                          className="collapsed"
                        >
                          <div className="card-header border-none px-3">
                            <label className="mb-0">Explore More</label>
                            <i className="fa fa-chevron-down fs-12 float-right"></i>
                          </div>
                        </a>
                        <div
                          id="collapseFive"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body p-3 pt-0 font-dark">
                            <div className="row">
                              <div className="col-md-12 order-lg-1">
                                <div className="row">
                                  {Inputs.explore_more !== null &&
                                    Inputs.explore_more.map((item, index) => (
                                      <>
                                        <div className="col-md-5">
                                          <div className="form-group">
                                            <label htmlFor={'_label_' + index}>Title</label>
                                            <input
                                              type="text"
                                              name="label"
                                              className="form-control"
                                              id={'_label_' + index}
                                              value={item.label}
                                              onChange={handleOnExploreMoreChange(index)}
                                            />
                                            {validator.current.message(
                                              'Title',
                                              item.label,
                                              'required',
                                              { className: 'error' }
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-md-6">
                                          <div className="form-group">
                                            <label htmlFor={'_value_' + index}>Link</label>
                                            <input
                                              type="text"
                                              name="value"
                                              className="form-control"
                                              id={'_value_' + index}
                                              value={item.value}
                                              onChange={handleOnExploreMoreChange(index)}
                                            />
                                            {validator.current.message(
                                              'Link',
                                              item.value,
                                              'required|max:255|url',
                                              { className: 'error' }
                                            )}
                                            <label
                                              style={{ color: '#505050' }}
                                              className="note mt-1"
                                            >
                                              {' '}
                                              {'(Ex. "https://www.example.com/".)'}
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-auto pr-0">
                                          <button
                                            className="btn btn-danger input-btn btn-block mt-4 w-48"
                                            onClick={handleDeleteExploreMoreOption(index)}
                                          >
                                            X
                                          </button>
                                        </div>
                                      </>
                                    ))}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-10 order-lg-1"></div>
                              <div className="col-md-2 order-lg-2">
                                <div className="row">
                                  <div className="col-md-9 text-right p-0">
                                    <button
                                      type="button"
                                      className="btn btn-custom text-white"
                                      onClick={(e) => handleAddExploreMoreOptions(e)}
                                    >
                                      + Add New
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none border-bottom mt-2">
                        <a
                          data-toggle="collapse"
                          data-target="#collapsesix"
                          aria-expanded="true"
                          aria-controls="collapsesix"
                          className="collapsed"
                        >
                          <div className="card-header border-none px-3">
                            <label className="mb-0">Footer Content</label>
                            <i className="fa fa-chevron-down fs-12 float-right"></i>
                          </div>
                        </a>
                        <div
                          id="collapsesix"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body p-3 pt-0 font-dark">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Title</label>
                                  <textarea
                                    className="form-control"
                                    name="footer_title"
                                    onChange={handleInputChanges('footer_title')}
                                    onKeyUp={handleInputChanges('footer_title')}
                                    defaultValue={Inputs.footer_title}
                                    placeholder="Title"
                                  ></textarea>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label>Description</label>
                                  {footerDescription !== undefined && (
                                    <ReactQuill
                                      theme="snow"
                                      value={footerDescription} // ✅ controlled value
                                      onChange={handleEditorChange} // ✅ updates state
                                      modules={modules}
                                      formats={formats}
                                      style={{ height: 300, marginBottom: '40px' }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-md-6">
                    <button
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/categories"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddCategory
